import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/global/layout';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { toast } from 'react-toastify';
import { login_success } from '../actions/user';

const MyGroups = () => {
  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const history = useNavigate();
  const [groups, setGroups] = useState<any[]>([]);

  useEffect(() => {
    if (user?.activeGroups) {
      setGroups(user.activeGroups);
    }
  }, [user]);

  const switchGroup = async (groupId: string) => {
    loader(true);
    try {
      const res = await ApiClient.post('api/user/switch-group', { groupId });
      if (res.success) {
        // Fetch updated user data
        const userRes = await ApiClient.get('api/user/detail', { id: user._id });
        if (userRes.success) {
          dispatch(login_success({ ...user, ...userRes.data }));
          toast.success(`Switched to ${res.data.groupName}`);
        }
      }
    } catch (error) {
      toast.error('Failed to switch group');
    }
    loader(false);
  };

  const getRoleName = (roleId: string, groupData: any) => {
    const cmLabel = groupData?.connectMeetLabel || 'ConnectMeet';
    const tyLabel = groupData?.testimonialLabel || 'Thank Yous';
    if (roleId === '65fc4a1e2e22cff912335e12') return 'Group Leader';
    if (roleId === '661014c611b714324fb36756') return 'Assistant Group Leader';
    if (roleId === '661014dc11b714324fb3675b') return `${cmLabel} Manager`;
    if (roleId === '69b62d0d9eb5f8c44e125b70') return `${tyLabel} Tracker`;
    return 'Member';
  };

  return (
    <Layout>
      <div className="wrapper_section">
        <h3 className="text-2xl font-semibold text-[#111827] mb-4">My Groups</h3>
        <p className="text-sm text-gray-500 mb-6">
          Select a group to switch your view
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {groups.map((group: any) => {
            const isCurrentGroup = group.groupId?._id === user.lastUsedGroupId?._id || 
                                  group.groupId === user.lastUsedGroupId;
            const groupIdValue = group.groupId?._id || group.groupId;
            const roleIdValue = group.customerRole?._id || group.customerRole;
            const isRemoved = group.status === 'removed';
            return (
              <div
                key={groupIdValue}
                className={`p-6 rounded-lg shadow-md transition-all ${
                  isRemoved
                    ? 'bg-gray-200 text-gray-500 cursor-not-allowed opacity-60'
                    : isCurrentGroup
                      ? 'bg-orange-500 text-white border-2 border-orange-600 cursor-pointer'
                      : 'bg-white hover:shadow-lg border border-gray-200 cursor-pointer'
                }`}
                onClick={() => !isCurrentGroup && !isRemoved && switchGroup(groupIdValue)}
              >
                <h4 className="text-xl font-semibold mb-2">
                  {group.groupId?.name || 'Unknown Group'}
                </h4>
                <p className={`text-sm ${isRemoved ? 'text-gray-500' : isCurrentGroup ? 'text-white' : 'text-gray-600'}`}>
                  Role: {getRoleName(roleIdValue, group.groupId)}
                </p>
                {isRemoved && (
                  <p className="mt-2 text-sm font-medium text-red-500">Removed from Group</p>
                )}
                {!isRemoved && isCurrentGroup && group.verifiedGroupLeader !== 'pending' && (
                  <p className="mt-2 text-sm font-medium">Currently Active</p>
                )}
                {!isRemoved && group.verifiedGroupLeader === 'pending' && (
                  <p className="mt-2 text-sm font-medium">Pending Verification</p>
                )}
              </div>
            );
          })}
        </div>

        {groups.length === 0 && (
          <p className="text-center text-gray-500 mt-8">
            You are not part of any groups yet.
          </p>
        )}
      </div>
    </Layout>
  );
};

export default MyGroups;